export const getWebHeaders = (clientPage, consumerVersion) => ({
    clientFeature: "pre-packs",
    clientPage,
    clientVersion: consumerVersion || "",
    widgetName: "PrePacksWidget",
    widgetVersion: VERSION,
});
//# sourceMappingURL=getWebHeaders.js.map